import { useQuery } from "@tanstack/react-query";
import { getDismissedAlerts } from "../../../api/alertsApi";
import { AlertItem } from "../../../pages/Alerts/alertsMockData";

export const DISMISSED_ALERTS_QUERY_KEY = ["alerts", "dismissed"];

export const useDismissedAlerts = () => {
  const { data, isLoading } = useQuery<AlertItem[]>(DISMISSED_ALERTS_QUERY_KEY, getDismissedAlerts);
  return { alerts: data ?? [], isLoading };
};
